<template>
	<!-- <a :href="item.platformUrl" target="_blank" @click="setClickData(item.tmpexbId)" class="exhibit-item-content" v-bind:class="{ closed: item.closed }"> -->
		<div class="item-content">
		
			<div class="item-content-info">
				<div class="item-content-info-coupon">
					<div class="item-content-info-coupon-img">
						<div class="item-content-info-coupon-img" @click="handleImageClick" style="cursor: pointer;">
							<span class="coupon-img-thumb">
								<img :src="item.imgFileUrl" :alt="item.imgFileNm" />
							</span>
						</div>
					</div>
					<div class="item-content-info-coupon-desc">
						<span class="cpndisc">{{ item.plcInfo }}</span>
						<span class="subtext">{{ item.arEventNm }}</span>
					</div>
				</div>
				<!-- <div class="item-content-info-title">{{ item.eventIntro }}</div> -->
				<div class="item-content-info-date">{{ item.date}}</div>
			</div>
			<!-- <div class="item-content-sub">
				<span class="subtitle">{{ item.brand }}</span>
				<span class="subtext">{{ item.desc }}</span>
			</div> -->
		</div>
	
	<!-- </a> -->
</template>

<script>

import { mapGetters } from 'vuex';
import { ACT_SET_CAMPN_CLICK_DATA } from '@/store/_act_consts';

export default {
	name: 'FestivalItemList',
	components: {},
	props: {
		item: null,
	},
	data: () => ({}),
	computed: {
		...mapGetters('common', [ 'campn']),
	},
	watch: {},
	created() {},
	mounted() {},
	methods: {
		handleImageClick() {
			// 부모 컴포넌트로 전달할 데이터 객체
			const eventData = {
				arEventNm: this.item.arEventNm,
				arNm: this.item.arNm,
				eventIntro: this.item.eventIntro,
				date: this.item.date,
				arEventId: this.item.arEventId,
				imgFileUrl: this.item.imgFileUrl,
				imgFileNm: this.item.imgFileNm
			};
			this.$emit('open-festival-modal', eventData);

			// 기존 setClickData 함수 호출이 필요하다면 여기에 추가합니다.
			// item.tmpexbId가 클릭 추적에 사용되는 ID라고 가정합니다.
			// if (this.item.tmpexbId) {
			// 	this.setClickData(this.item.tmpexbId);
			// }
		},
		setClickData(clickTrgtId) {
			// api 호출
			this.$store
				.dispatch(`common/${ACT_SET_CAMPN_CLICK_DATA}`, {
					clickTrgtId,
					clickTrgtTyp: "WNN_TMPEXB",
					campnId: this.campn.campnId,
				})
				.then((res) => {})
				.catch((e) => {
					console.error(e);
				});
		}
	},
};
</script>
